export default "__VITE_PUBLIC_ASSET__5cf187fa__"